/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Notifications_initialViewer = {
    readonly " $fragmentRefs": FragmentRefs<"Conversations_viewer" | "NotificationsIcon_viewer">;
    readonly " $refType": "Notifications_initialViewer";
};
export type Notifications_initialViewer$data = Notifications_initialViewer;
export type Notifications_initialViewer$key = {
    readonly " $data"?: Notifications_initialViewer$data;
    readonly " $fragmentRefs": FragmentRefs<"Notifications_initialViewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "Notifications_initialViewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isClient",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isClient",
      "selections": [
        {
          "kind": "Defer",
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "Conversations_viewer",
              "args": null
            }
          ]
        },
        {
          "kind": "Defer",
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "NotificationsIcon_viewer",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = 'c6cb02d8a70fd78b905c9e772b728f8d';
export default node;
